<template>
  <div class="row about" id="o-akcji-mp">
    <div class="col-12 text-center">
      <div class="about__box" v-if="content.data.test_ab.active">
        <Ab
          @sample="(value) => (test_ab_content = value)"
          :weight="{ test_ab_contentA: 50, test_ab_contentB: 50 }"
        >
          <h2
            class="about__headline"
            slot="test_ab_contentA"
            v-html="content.data.test_ab.about_a_header"
          ></h2>
          <div
            class="about__content"
            slot="test_ab_contentA"
            v-html="content.data.test_ab.about_a_content"
          ></div>
          <h2
            class="about__headline"
            slot="test_ab_contentB"
            v-html="content.data.test_ab.about_b_header"
          ></h2>
          <div
            class="about__content"
            slot="test_ab_contentB"
            v-html="content.data.test_ab.about_b_content"
          ></div>
        </Ab>
      </div>
      <div v-else class="about__box">
        <h2 class="about__headline" v-html="content.data.about.header"></h2>
        <div class="about__content" v-html="content.data.about.content"></div>
        <img
          v-if="content.data.about.img && content.data.about.img !== ''"
          :src="content.data.about.img"
          alt="10"
        />
        <div>
          <router-link
            v-if="content.data.about.btn"
            class="about__btn"
            :to="content.data.about.btn.link"
          >
            {{ content.data.about.btn.title }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ab from "vue-ab";
export default {
  name: "About",
  inject: ["content"],
  components: { Ab },
  data() {
    return {
      title: "about",
    };
  },
};
</script>
